var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 5,
    x2: 16,
    y2: 5,
    id: "Path",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 10,
    y2: 12,
    id: "Path",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 20,
    y2: 12,
    id: "Path",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 19,
    x2: 20,
    y2: 19,
    id: "Path",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round",
    cx: 18,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round",
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round",
    cx: 6,
    cy: 19,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.542f9f06c8ed4e1898a192c66c7ead8d.svg";
export { ForwardRef as ReactComponent };